import { BrowserRouter } from "react-router-dom";
import { ConfigProvider } from "antd";
import ptBR from "antd/locale/pt_BR";
import { ChildrenDto } from "../types";
import { SidebarProvider } from "./SidebarProvider";
import { QueryClientProvider } from '@tanstack/react-query';
import { queryClient } from '../config/connection/react-query';
import Notifications from "../components/Notifications/Notifications";
import { ReportProvider } from "./ReportContext";

export const AppProvider = ({ children }: ChildrenDto) => {
    return (
        <QueryClientProvider client={queryClient}>
            {/* Sem o locale, os textos embutidos do antd (tabela vazia, dicas de ordenacao, Select sem
              * opcoes, botoes de modal) aparecem em ingles. So troca textos, nao muda o visual. */}
            <ConfigProvider locale={ptBR}>
                <Notifications />
                <BrowserRouter>
                    <ReportProvider>
                        <SidebarProvider>
                            {children}
                        </SidebarProvider>
                    </ReportProvider>
                </BrowserRouter>
            </ConfigProvider>
        </QueryClientProvider>
    );
};